import { render, staticRenderFns } from "./PaymentAgreement.vue?vue&type=template&id=e6ceb202"
import script from "./PaymentAgreement.vue?vue&type=script&lang=js"
export * from "./PaymentAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports